<template>
  <div class="tasks-list">
    <div class="tasks-list-line">
      <div class="tasks-list-line-scroll">
        <div v-for="({ color, title, desc, time }, i) in shortList"
          :key="i" :class="`tasks-list-task tasks-list-${color}`">
            <h4>{{ title }}</h4>
            <p>{{ desc }}</p>
            <b>{{ time }}</b>
        </div>
      </div>
    </div>
    <div @click="more = !more" v-if="!more" class="view-more">
      View more
    </div>
  </div>
</template>

<script>
import tasksData from '@/data/tasks.json'
import { matchMedia } from '@/utils/helpers'
export default {
  data: function () {
    return {
      tasks: tasksData,
      more: false,
      sliceSize: matchMedia(undefined, 4)
    }
  },
  computed: {
    shortList () {
      return this.more ? this.tasks : this.tasks.slice(0, this.sliceSize)
    }
  },
  mounted () {
    if (matchMedia(true, false)) {
      this.$gsap.to('.tasks-list-line-scroll', {
        x: -500,
        ease: 'none',
        scrollTrigger: {
          trigger: '.tasks-list-line-scroll',
          // start: 'top bottom',
          // end: '+=150',
          scrub: 1
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .tasks-list {
    padding: 20px 0;

    &-task {
      border-width: 2px;
      border-style: solid;
      box-sizing: border-box;
      height: 150px;
      position: relative;
      border-radius: 11px;
      text-align: left;
      padding: 15px 20px;
      vertical-align: middle;
      white-space: normal;
      margin-bottom: 20px;
      transition: all .9s cubic-bezier(0.075, 0.82, 0.165, 1);
      color: #fff;

      &:hover {
        color: white;
        transform: translateX(-10px);

        b {
          color: white;
        }
      }

      h4 {
        margin: 0 0 10px 0;
        font-size: 25px;
        font-family: 'ProximaNova-Bold';
      }

      p {
        margin: 0;
        font-size: 16px;
        font-family: 'ProximaNova-Regular';
        line-height: 26px;
      }

      b {
        position: absolute;
        bottom: 15px;
        font-size: 14px;
        font-family: 'ProximaNova-Bold';
      }
    }

    $purple: #aa6ffb;
    $blue: #027fff;
    $green: #19c29b;
    $yellow: #fcc719;

    &-purple {
      border-color: $purple;
      background-color: $purple;

      &:hover {
        background-color: $purple;
      }

      b {
        color: #fff;
      }
    }

    &-blue {
      border-color: $blue;
      background-color: $blue;

      &:hover {
        background-color: $blue;
      }

      b {
        color: #fff;
      }
    }

    &-green {
      border-color: $green;
      background-color: $green;

      &:hover {
        background-color: $green;
      }

      b {
        color: #fff;
      }
    }

    &-yellow {
      border-color: $yellow;
      background-color: $yellow;
      color: var(--primary-black);

      &:hover {
        background-color: $yellow;
        color: var(--primary-black);

        b {
          color: var(--primary-black) !important;
        }
      }

      b {
        color: var(--primary-black);
      }
    }

    @media #{$desktop} {
      padding: 30px 0;

      &-line {
        white-space: nowrap;
        overflow: hidden;
        margin-left: -100px;
        margin-right: -20px;
      }

      &-task {
        border-width: 2px;
        border-style: solid;
        box-sizing: border-box;
        width: 318px;
        height: 189px;
        position: relative;
        border-radius: 11px;
        text-align: left;
        padding: 20px;
        display: inline-block;
        vertical-align: middle;
        margin: 0 10px;
        white-space: normal;
      }

      .view-more {
        display: none;
      }
    }
  }
</style>
